import { Group, Text } from '@grovus/design-system'

/**
 * The footnote: one paragraph under the table, the wireframe's shape - a left bar in the
 * bad ramp (the wireframe's own accent token, which the design system carries as
 * `bad`; the app never defines `--color-accent`, and an undefined variable paints the
 * bar transparent), the text at muted ink. The sentence is built at render time from
 * `footnote.ts`'s variables, so it cannot go stale when the data moves.
 */
export function Footnote({ text }: { text: string }) {
  return (
    <Group
      gap="sm"
      align="stretch"
      wrap="nowrap"
      style={{ maxWidth: 780 }}
      data-testid="hypotheses-footnote"
    >
      <span className="hyp-footnote-bar" aria-hidden="true" style={{ width: 3, alignSelf: 'stretch', flex: 'none' }} />
      <Text size="sm" className="grv-muted">
        {text}
      </Text>
    </Group>
  )
}